import { render, staticRenderFns } from "./VWidget.vue?vue&type=template&id=24aa3780&scoped=true&"
import script from "./VWidget.vue?vue&type=script&lang=js&"
export * from "./VWidget.vue?vue&type=script&lang=js&"
import style0 from "./VWidget.vue?vue&type=style&index=0&id=24aa3780&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aa3780",
  null
  
)

export default component.exports